import React from 'react';
import * as Styled from './VideoPlayer.styled';
var VideoPlayer = function (_a) {
    var _b = _a.vimeoId, vimeoId = _b === void 0 ? undefined : _b, padding = _a.padding, title = _a.title;
    var videoSrc = '';
    var isVimeo = vimeoId !== undefined;
    if (isVimeo) {
        videoSrc = "https://player.vimeo.com/video/".concat(vimeoId, "?&byline=0&title=0&vimeo_logo=0&pip=0&chromecast=0&airplay=0&transcript=0&sidedock=0");
    }
    if (!isVimeo)
        return null;
    return (React.createElement(Styled.ResponsiveVideoContainer, { paddingTop: padding !== null && padding !== void 0 ? padding : '' }, isVimeo && (React.createElement(Styled.EmbeddedVideo, { src: videoSrc, title: title, allow: "autoplay; fullscreen; picture-in-picture", allowFullScreen: true }))));
};
export default VideoPlayer;
